<template>
  <a-col :span="24" class="itemMail" >
    <a-card class="noPadding" :bodyStyle="{padding:0}">
        <a-collapse-panel  class="noPadding">
          <template slot="header" class="noPadding">

            <a-row type="flex" justify="space-between" align="middle" style="padding: 10px 10px">

              <a-col :span="6">
                
                <p class="nombre"><b>{{
                    message.subject
                  }}</b></p>

                <p class="info">{{fechaEnvio}}</p>
                <p class="info">De: {{message.from}}</p>
                <p class="info">Para: {{message.to}}</p>
              </a-col>

              <a-col :span="2">
                <template>
                  <div>
                    <p class="arriba">Recibido</p>
                    <p class="abajo">
                      <a-tooltip>
                        <template v-if="message.delivery" #title>{{fecha_completa(message.delivery)}}</template>
                        <a-icon :type="message.delivery ? 'check-circle':'close-circle'" :style="`font-size:20px;color:${message.delivery ? 'green':'red'}`"/>
                      </a-tooltip>
                    </p>
                  </div>
                </template>
              </a-col>

              <a-col :span="2">
                <template>
                  <div>
                    <p class="arriba">Abierto</p>
                    <p class="abajo">
                      <a-tooltip>
                        <template v-if="message.open" #title>{{fecha_completa(message.open)}}</template>
                        <a-icon :type="message.open ? 'check-circle':'close-circle'" :style="`font-size:20px;color:${message.open ? 'green':'red'}`"/>
                      </a-tooltip>
                    </p>
                  </div>
                </template>
              </a-col>

              <a-col :span="2">
                <template>
                  <div>
                    <p class="arriba">Click</p>
                    <p class="abajo">
                      <a-tooltip>
                        <template v-if="message.click" #title>{{fecha_completa(message.click)}}</template>
                        <a-icon :type="message.click ? 'check-circle':'close-circle'" :style="`font-size:20px;color:${message.click ? 'green':'red'}`"/>
                      </a-tooltip>
                    </p>
                  </div>
                </template>
              </a-col>


            </a-row>
          </template>

        </a-collapse-panel>
    </a-card>

  </a-col>
 
</template>

<script>
import moment from 'moment'
import detailHover from './DetailHover.vue'
import utils from '../service/service.js'
import VueApexCharts from 'vue-apexcharts'
import Vue from "vue";
import EmailInsights from "@/components/EmailInsights.vue";
import ABtestResults from "@/components/ABtestResults.vue";
import axios from "axios";
import StatusSummary from "@/components/StatusSummary.vue";

Vue.component('apexchart', VueApexCharts)

moment.locale('ES');

export default {
  name: 'itemMessage',
  components: {
    StatusSummary,
    ABtestResults,
    EmailInsights,
    detailHover,
  },
  props: {
    message: {},
    keepOpen: {
      type: Boolean,
      default: false
    },
  },
  mixins:[utils],
  data() {
    return {
      visiblePreview: false,
      visibleSendTest: false,
      loading:'',
      loadingSendTest: false,
      formSendTest: {
        emails: ''
      },
      formularioRules:{
        email: { rules: [{ required: true, message: 'Ingrese al menos 1 Email'}]}
      },
      listas_incluir:[],
      listas_excluir:[],
      mailings_excluir:[],
      template_name: '',
      loadingTemplateName: false,

  }
  },
  mounted: function() {
    this.formSendTest.emails = JSON.parse(localStorage.getItem('test_emails'));
    if(this.opens) {
      this.getTemplateName();
    }

  },
  methods:{

    promedio(costo, cantidad_envios){
      if(cantidad_envios > 0){
        return 'USD '+ (costo / cantidad_envios).toFixed(2);
      }else
        return '-';
    },
    porcentaje(cantidad, total){
      if(total>0){
        cantidad = parseInt(cantidad);
        total = parseInt(total);
        var resultado = ((cantidad / total) * 100).toFixed(2);
        return resultado + '%';
      }else
        return '-'
    },

    fecha_completa(fecha){
      return moment(fecha, 'YYYY/MM/DD hh:mm:ss SSS', 'es').format('LLL');
    }
  },
    computed:{
    fechaEnvio: function () {
      var $this = this
      var date = this.message.sent_at
      var today = moment().format(today,'YYYY/MM/D hh:mm:ss LLL')
      date = moment().format(date,'YYYY/MM/D hh:mm:ss LLL')
      return "Enviado el " + moment(date, 'YYYY-MM-DD hh:mm:ss', 'es').format('LLL');
    },


  },
  watch: {

    mailing: function() {
      this.mapMailings();
      this.mapListas();
    },


  }

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .estadoBadge {
    width: 42px;
    height: 42px;
    border-radius: 4px;
    color: white;
    background: #ededed;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  p {
    margin-bottom: 0px;
  }
  p.nombre {
      text-align: left;
      font-size: 16px;
  }
  p.info {
      text-align: left;
      font-size: 12px;
      margin-top: 0px;
    line-height: 16px;
  }
  .itemMail{
    margin-bottom: 20px;
  }
  .ant-collapse > .ant-collapse-item:last-child, .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header{
    border-bottom: 0px;
    box-shadow: 2px 1px 5px -4px;
  }
  .contenido_description{
    margin-left: 5%;
    padding-left: 7px;
    text-align: left;
    margin-bottom: 15px;
  }
  .caracteristicas{
    margin-bottom: 20px
  }
  .caracteristicas .title{
    font-size: 16px;
    color: #333333;
  }
  .caracteristicas .icon{
    margin-right: 10px;
  }
  .caracteristicas .info{
    text-align: left;
  }

  .caracteristicas .info{
    text-align: left;
  }
  .loading{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .noPadding {
    padding: 0 !important;
  }

</style>